"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'recommend',
  cname: '推荐',
  // 标题名称
  icon: 't-icon-zujian-shangpinliebiao',
  configName: 'c_recommend',
  // 右侧配置名称
  type: 1,
  // 0 基础组件 1 营销组件 2 工具组件
  defaultName: 'recommend',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mobileTheme'])),
  watch: {
    pageData: {
      handler: function handler(nVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler() {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      // 默认初始化数据禁止修改
      defaultConfig: {
        isHide: false,
        name: 'recommend',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '推荐'
        },
        // ===== 卡片1：今日必买（大卡）=====
        card1Title: {
          isShow: 1,
          title: '卡片1标题',
          val: '今日必买',
          place: '请输入标题',
          max: 8
        },
        card1Tag: {
          isShow: 1,
          title: '卡片1角标',
          val: '今日好价',
          place: '请输入角标文字',
          max: 8
        },
        card1SubTitle: {
          isShow: 1,
          title: '卡片1副标题',
          val: '基地直采/当日采摘/冷链锁鲜',
          place: '请输入副标题',
          max: 30
        },
        card1Img: {
          isShow: 1,
          tabTitle: '卡片1图片',
          title: '卡片1图片',
          tips: '建议上传大小：宽200px，高200px',
          header: '卡片1图片',
          url: ''
        },
        card1GoodsName: {
          isShow: 1,
          title: '商品名称',
          val: '皖北牛羊肉',
          place: '请输入商品名称',
          max: 10
        },
        card1Desc1: {
          isShow: 1,
          title: '商品描述1',
          val: '安徽原产',
          place: '请输入描述',
          max: 10
        },
        card1Desc2: {
          isShow: 1,
          title: '商品描述2',
          val: '现采现发',
          place: '请输入描述',
          max: 10
        },
        card1Link: {
          isShow: 1,
          title: '链接',
          val: '',
          place: '请选择链接',
          max: 100
        },
        card1BgColor: {
          tabTitle: '颜色设置',
          title: '卡片1背景色',
          color: [{
            item: '#FDEAD9'
          }],
          default: [{
            item: '#FDEAD9'
          }]
        },
        // ===== 卡片2：江淮风物（中卡）=====
        card2Title: {
          isShow: 1,
          title: '卡片2标题',
          val: '江淮风物',
          place: '请输入标题',
          max: 8
        },
        card2SubTitle: {
          isShow: 1,
          title: '卡片2副标题',
          val: '明日可提',
          place: '请输入副标题',
          max: 20
        },
        card2Img: {
          isShow: 1,
          tabTitle: '卡片2图片',
          title: '卡片2图片',
          tips: '建议上传大小：宽200px，高200px',
          header: '卡片2图片',
          url: ''
        },
        card2Tag: {
          isShow: 1,
          title: '卡片2标签',
          val: '现采现发',
          place: '请输入标签文字',
          max: 8
        },
        card2Link: {
          isShow: 1,
          title: '链接',
          val: '',
          place: '请选择链接',
          max: 100
        },
        card2BgColor: {
          title: '卡片2背景色',
          color: [{
            item: '#FBE3E3'
          }],
          default: [{
            item: '#FBE3E3'
          }]
        },
        // ===== 卡片3：团长推荐（中卡）=====
        card3Title: {
          isShow: 1,
          title: '卡片3标题',
          val: '团长推荐',
          place: '请输入标题',
          max: 8
        },
        card3SubTitle: {
          isShow: 1,
          title: '卡片3副标题',
          val: '团长口碑推荐',
          place: '请输入副标题',
          max: 20
        },
        card3Img: {
          isShow: 1,
          tabTitle: '卡片3图片',
          title: '卡片3图片',
          tips: '建议上传大小：宽200px，高200px',
          header: '卡片3图片',
          url: ''
        },
        card3Tag: {
          isShow: 1,
          title: '卡片3标签',
          val: '口碑推荐',
          place: '请输入标签文字',
          max: 8
        },
        card3Link: {
          isShow: 1,
          title: '链接',
          val: '',
          place: '请选择链接',
          max: 100
        },
        card3BgColor: {
          title: '卡片3背景色',
          color: [{
            item: '#E3F3E8'
          }],
          default: [{
            item: '#E3F3E8'
          }]
        }
      },
      configObj: null,
      pageData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.num) {
        _this.pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
        _this.setConfig(_this.pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      this.configObj = data;
    }
  }
};